import React from 'react'
import '../../../assets/react-toolbox/theme.css';
import theme from '../../../assets/react-toolbox/theme.js';
import ThemeProvider from 'react-toolbox/lib/ThemeProvider';
import IconButton from 'react-toolbox/lib/button/IconButton';


export const ZoomController = props => {
    return (
        <ThemeProvider theme={theme}>
            <div className="row zoomController">
                <div className="hidden-xs">
                    <div className="zoomButton plus">
                        <IconButton accent icon="add" onClick={props.handleZoomIn}/>
                    </div>
                    <div className="zoomButton minus">
                        <IconButton accent icon="remove" onClick={props.handleZoomOut}/>
                    </div>
                </div>

            </div>
        </ThemeProvider>
    )
};


// WEBPACK FOOTER //
// ./src/components/Map/Common/ZoomController.js